import gamerDen from '../assets/gamerDen.png'
import ipaddrtrckr from '../assets/ipaddrtrckr.png'
import bug from '../assets/bug-tracker.png'



export const projectList=[
    {
        name:"gamer-den",
        image:gamerDen,
        skills:"React, HTML, CSS, Chakra UI, TypeScript",
        conn:'https://gamer-den.netlify.app/'
    },
    {
        name:"ip-address-tracker",
        image:ipaddrtrckr,
        skills:"React, HTML, CSS",
        conn:'https://deeps-ip-address-tracker.netlify.app/'
    },
    {
        name:"bug-tracker",
        image:bug,
        skills:"React, Typescript,NextJS",
        conn:'https://bug-tracker-hazel.vercel.app/'
    },
   
]